import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import clsx from 'clsx';
import { FC, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { SidePanel } from 'src/components/sidePanel/SidePanel';
import { isObjectEmpty } from 'src/helpers';
import {
  IRuleValidation,
  IRuleValidationData,
  useCreateRuleValidationMutation,
  useUpdateRuleValidationMutation,
} from '../../../redux/services/settings';
import { CustomTypography } from '../../custom/CustomTypography';
import styles from './EditRuleValidation.module.css';

interface IEditRuleValidationProps {
  isOpen: boolean;
  onClose: () => void;
  selectedRuleValidation?: IRuleValidation;
}

export const EditRuleValidation: FC<IEditRuleValidationProps> = ({
  isOpen,
  onClose,
  selectedRuleValidation,
}) => {
  const [createRuleValidation] = useCreateRuleValidationMutation();
  const [updateRuleValidation] = useUpdateRuleValidationMutation();

  const headerText = selectedRuleValidation
    ? 'Редактировать правило валидации'
    : 'Создать правило валидации';

  const {
    handleSubmit,
    register,
    formState: { dirtyFields },
    reset,
  } = useForm<IRuleValidationData>();

  useEffect(() => {
    reset({
      title: selectedRuleValidation?.title || '',
      error: selectedRuleValidation?.error || '',
      regex: selectedRuleValidation?.regex || '',
      active: selectedRuleValidation?.active || false,
    });
  }, [selectedRuleValidation]);

  const onSubmit = async (data: IRuleValidationData) => {
    try {
      if (selectedRuleValidation) {
        await updateRuleValidation({
          id: selectedRuleValidation.id,
          body: data,
        }).unwrap();
      } else {
        await createRuleValidation(data).unwrap();
      }

      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <SidePanel
      onClose={onClose}
      isOpen={isOpen}
      title={headerText}
      isNoBackdrop
      handleConfirm={handleSubmit(onSubmit)}
      disabledButtonConfirm={isObjectEmpty(dirtyFields)}
    >
      <form>
        <CustomTypography className={clsx(styles.label, 'text-14')}>Название</CustomTypography>
        <TextField
          className="custom"
          fullWidth
          variant="standard"
          placeholder="Введите название"
          {...register('title')}
        />
        <CustomTypography color="grey" className={clsx('text-12', styles.description)}>
          Название поля в системе
        </CustomTypography>
        <CustomTypography className={clsx(styles.label, 'text-14')}>Текст ошибки</CustomTypography>
        <TextField
          className="custom"
          fullWidth
          variant="standard"
          placeholder="Введите текст ошибки"
          {...register('error')}
        />
        <CustomTypography color="grey" className={clsx('text-12', styles.description)}>
          Тест ошибки, если сработает правило валидации
        </CustomTypography>
        <CustomTypography className={clsx(styles.label, 'text-14')}>
          Регулярное выражение
        </CustomTypography>
        <TextField
          className="custom"
          fullWidth
          variant="standard"
          placeholder="Введите текст ошибки"
          {...register('regex')}
        />
        <CustomTypography color="grey" className={clsx('text-12', styles.description)}>
          Регулярное выражение, описывающее правило валидации в формате ^\S+$
        </CustomTypography>
        <div className={styles.switcher}>
          <CustomTypography className={'text-14'}>Активность</CustomTypography>
          <Switch
            defaultChecked={selectedRuleValidation?.active || false}
            {...register('active')}
          />
        </div>
      </form>
    </SidePanel>
  );
};
